import React, { FunctionComponent } from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import MontoMonedaTexto from '../../../../base/components/PopoverMonto/MontoMonedaTexto'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}))

interface DefinicionCollapseProps {
  definicion: any[]
  unidadMedidaBase: string // Reemplaza con tu tipo exacto si es posible
}

const DefinicionCollapse: FunctionComponent<DefinicionCollapseProps> = ({
  definicion,
  unidadMedidaBase,
}) => {
  if (!definicion || definicion.length === 0) return <span>-</span>

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table sx={{ width: '100%' }} size="small" aria-label="unidades tabla">
        <TableHead>
          <TableRow>
            <StyledTableCell width={50} sx={{ pl: 1, pr: 1 }}>
              Código
            </StyledTableCell>
            <StyledTableCell width={350} sx={{ pl: 1, pr: 1 }}>
              Nombre
            </StyledTableCell>
            <StyledTableCell sx={{ pl: 1, pr: 1 }} align="right">
              Cantidad
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {definicion.map((item, index) => {
            const unidad = item.unidadMedida
            return (
              <TableRow key={index}>
                <StyledTableCell sx={{ pl: 1, pr: 1 }}>
                  {unidad?.codigoUnidadMedida ?? '-'}
                </StyledTableCell>
                <StyledTableCell>{unidad?.nombreUnidadMedida ?? '-'}</StyledTableCell>
                <StyledTableCell align="right">
                  <MontoMonedaTexto
                    id={`cantidad-base-${item.id}`}
                    label={undefined}
                    monto={item.cantidadBase ?? 0}
                    sigla={unidadMedidaBase}
                    onChange={() => {}}
                  />
                </StyledTableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DefinicionCollapse
